import api from './HttpService';
import { COMPANY } from '../configs/ApiActionUrl';

async function getAll(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  try {
    const res = await api.get(COMPANY.LIST + query);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function add(postData) {
  const res = await api.post(COMPANY.ADD, postData);
  return res;
}

async function getItem(code) {
  const res = await api.get(`${COMPANY.EDIT}/${code}`);
  return res;
}

async function update(code, postData) {
  const res = await api.patch(`${COMPANY.UPDATE}/${code}`, postData);
  return res;
}

async function deleteItem(code) {
  const res = await api.delete(`${COMPANY.DELETE}/${code}`);
  return res;
}

async function getActiveItem() {
  const res = await api.get(`${COMPANY.ACTIVE}`);
  return res;
}

const companyService = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveItem
};

export default companyService;
